export * from './casa/casa.component';
export * from './customer/customer-edit/customer-edit.component';
export * from './customer/customer-group/customer-group.component';
export * from './customer/customer-information/customer-information.component';
export * from './customer/customer-information-detail/customer-information-detail.component';
export * from './customer/customer-relationship/customer-relationship-type.component';
export * from './customer/customer-search/customer-search.component';
export * from './customer/customer.component';
export * from './customer/prospect-customer/prospect-customer.component';
export * from './kyc-checklist/kyc-checklist.component';